/* HTN draft fix 2026-10-20: Flexible Deposits terms modal placeholders.
   The app block renders terms with {deposit_percentage} etc and only
   substitutes them in the summary line, not in the terms modal.
   This theme script uses the SAME public app config endpoint the app
   itself fetches (/apps/deposits/config) plus the current variant
   price shown in the Pay-in-Full option, so the tick-box terms show
   the real per-product deposit %, $ deposit, $ balance and period.
   It does not change app settings, checkout, or order behaviour. */
(function () {
  var EMAIL = (window.HTN_DEPOSIT_CONTACT_EMAIL || 'contact@huntthenight.com.au');
  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function parseMoney(txt) {
    var v = parseFloat(String(txt || '').replace(/[^0-9.]/g, ''));
    return isFinite(v) ? v : null;
  }
  function replaceInTerms(values) {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (/\{(deposit_percentage|deposit_amount|balance_amount|due_period|contact_email)\}/.test(n.textContent)) nodes.push(n);
    }
    nodes.forEach(function (node) {
      var txt = node.textContent
        .replaceAll('{deposit_percentage}', values.pct);
      if (values.deposit) {
        txt = txt
          .replaceAll('{deposit_amount}', values.deposit)
          .replaceAll('{balance_amount}', values.balance);
      }
      node.textContent = txt
        .replaceAll('{due_period}', values.due)
        .replaceAll('{contact_email}', EMAIL);
    });
    return nodes.length;
  }
  function runForSelector(selector) {
    var productId = selector.dataset.productId;
    var proxy = selector.dataset.proxyUrl || '/apps/deposits/config';
    if (!productId) return;
    var params = new URLSearchParams();
    params.set('product_id', productId);
    var variantId = selector.dataset.variantId;
    if (variantId) params.set('variant_id', variantId);
    fetch(proxy + '?' + params.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cfg) {
        if (!cfg || !cfg.enabled) return;
        // Current full price: prefer the app's own Pay-in-Full price element.
        var fullEl = selector.querySelector('.deposit-selector__option-price--full');
        var price = fullEl ? parseMoney(fullEl.textContent) : null;
        if (price == null) {
          var amtEl = selector.querySelector('[id^="deposit-amount-display-"]');
          price = null; // fall through: cannot derive reliably, still fix %/period/email
          void amtEl;
        }
        var pctRaw = Number(cfg.depositValue);
        var values = {
          pct: isFinite(pctRaw) ? (String(pctRaw).replace(/\.0$/, '') + '%') : '',
          due: cfg.duePeriodText || selector.dataset.fallbackDuePeriod || '8 weeks',
          deposit: '',
          balance: ''
        };
        if (price != null && isFinite(pctRaw) && String(cfg.depositType || 'PERCENTAGE').toUpperCase() === 'PERCENTAGE') {
          var dep = price * pctRaw / 100;
          values.deposit = money(dep);
          values.balance = money(price - dep);
        }
        // Only substitute amounts we actually derived; never guess.
        var apply = function () {
          // If amounts unknown, temporarily protect amount placeholders.
          var walkerNodes = replaceInTerms(values);
          return walkerNodes;
        };
        apply();
        // App JS may re-render late; re-apply a few times.
        var tries = 0;
        var iv = setInterval(function () {
          tries += 1;
          apply();
          if (tries >= 8) clearInterval(iv);
        }, 700);
      })
      .catch(function () { /* leave app behaviour untouched on failure */ });
  }
  function init() {
    document.querySelectorAll('.deposit-selector').forEach(runForSelector);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
